/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import { Alert, Snackbar, Stack } from '@mui/material'
import React, { useEffect } from 'react'

export const SnackBarMessage: React.FC<any> = (props) => {
  const [openSnackBar, setOpenSnackBar] = React.useState(props.snacBarValue.snackFlag);

  useEffect(() => {
    setOpenSnackBar(props.snacBarValue.snackFlag);
  }, [props.snacBarValue]);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
    props.snacBarValue.snackFlag = false;
  };

  return (
    <div>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar open={openSnackBar} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
          <Alert onClose={handleClose} severity={props.snacBarValue.type} sx={{ width: '100%', fontSize: '1.2rem' }}>
            {props.snacBarValue.message}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  )
}